const packaged_products_images = [
    {
        name: "Sunfeast Mom's Magic Cashew and Almonds Cookies",
        price: "₹  84 / 584 g",
        priceint: 84,
        weight: 584,
        unit: "g",
        src: require("./Sunfeast Mom's Magic Cashew and Almonds Cookies.webp")
      },
      {
        name: "UNIBIC Fruit and Nut Cookies",
        price: "₹  22 / 75 g",
        priceint: 22,
        weight: 75,
        unit: "g",
        src: require("./UNIBIC Fruit and Nut Cookies.webp")
      },
      {
        name: "BRITANNIA Gold Marie Biscuit",
        price: "₹  79 / 4x117 g",
        priceint: 79,
        weight: 468,
        unit: "g",
        src: require("./BRITANNIA Gold Marie Biscuit.webp")
      },
      {
        name: "Sunfeast Dark Fantasy Yumfills Cookie Cake",
        price: "₹  90 / 253 g",
        priceint: 90,
        weight: 253,
        unit: "g",
        src: require("./Sunfeast Dark Fantasy Yumfills Cookie Cake.webp")
      },
      {
        name: "BRITANNIA Bourbon Biscuits Cream Sandwich",
        price: "₹  86 / 4x100 g",
        priceint: 86,
        weight: 400,
        unit: "g",
        src: require("./BRITANNIA Bourbon Biscuits Cream Sandwich.webp")
      },
      {
        name: "Sunfeast Dark Fantasy Choco Fills Cream Filled",
        price: "₹  106 / 300 g",
        priceint: 106,
        weight: 300,
        unit: "g",
        src: require("./Sunfeast Dark Fantasy Choco Fills Cream Filled.webp")
      },
      {
        name: "Dukes Natural goodness of Oats, Wheat, and Honey Digestive",
        price: "₹  157 / 10x0.1 kg",
        priceint: 157,
        weight: 1,
        unit: "kg",
        src: require("./Dukes Natural goodness of Oats, Wheat, and Honey Digestive.webp")
      },
      {
        name: "UNIBIC Cashew Badam Cookies",
        price: "₹  69 / 300 g",
        priceint: 69,
        weight: 300,
        unit: "g",
        src: require("./UNIBIC Cashew Badam Cookies.webp")
      },
      {
        name: "UNIBIC Choco Kiss Cream Filled",
        price: "₹  18 / 60 g",
        priceint: 18,
        weight: 60,
        unit: "g",
        src: require("./UNIBIC Choco Kiss Cream Filled.webp")
      },
      {
        name: "Dukes Kaju Kukkies with real taste Cookies",
        price: "₹  64 / 400 g",
        priceint: 64,
        weight: 400,
        unit: "g",
        src: require("./Dukes Kaju Kukkies with real taste Cookies.webp")
      },
      {
        name: "BRITANNIA Good Day Pista Badam Cookies",
        price: "₹ 106 / 600 g",
        priceint: 106,
        weight: 600,
        unit: "g",
        src: require("./BRITANNIA Good Day Pista Badam Cookies.webp")
    },
    {
        name: "PARLE Hide and Seek Chocolate Chip Cookies",
        price: "₹ 101 / 400 g",
        priceint: 101,
        weight: 400,
        unit: "g",
        src: require("./PARLE Hide and Seek Chocolate Chip Cookies.webp")
    },
    {
        name: "Dukes Nibbles Cheese Cracker",
        price: "₹ 36 / 150 g",
        priceint: 36,
        weight: 150,
        unit: "g",
        src: require("./Dukes Nibbles Cheese Cracker.webp")
    },
    {
        name: "UNIBIC Choco Cookies",
        price: "₹ 72 / 250 g",
        priceint: 72,
        weight: 250,
        unit: "g",
        src: require("./UNIBIC Choco Cookies.webp")
    },
    {
        name: "PARLE Marie Biscuit",
        price: "₹ 98 / 800g",
        priceint: 98,
        weight: 800,
        unit: "g",
        src: require("./PARLE Marie Biscuit.webp")
    },
    {
        name: "KARACHI BAKERY Fruit Bakery Biscuit",
        price: "₹ 151 / 400 g",
        priceint: 151,
        weight: 400,
        unit: "g",
        src: require("./KARACHI BAKERY Fruit Bakery Biscuit.webp")
    },
    {
        name: "UNIBIC Assorted Cookies",
        price: "₹ 123 / 6x75 g",
        priceint: 123,
        weight: 450,
        unit: "g",
        src: require("./UNIBIC Assorted Cookies.webp")
    },
    {
        name: "PARLE Monaco Salted Biscuit",
        price: "₹ 36 / 200 g",
        priceint: 36,
        weight: 200,
        unit: "g",
        src: require("./PARLE Monaco Salted Biscuit.webp")
    },
    {
        name: "PARLE Happy Happy Choco-chip Cookies",
        price: "₹ 70 / 4x100 g",
        priceint: 70,
        weight: 400,
        unit: "g",
        src: require("./PARLE Happy Happy Choco-chip Cookies.webp")
    },
    {
        name: "4700BC Salted Popcorn",
        price: "₹ 28 / 90 g",
        priceint: 28,
        weight: 90,
        unit: "g",
        src: require("./4700BC Salted Popcorn.webp")
        },
        {
        name: "ProV Mini Almonds Roasted and Salted",
        price: "₹ 28 / 18 g",
        priceint: 28,
        weight: 18,
        unit: "g",
        src: require("./ProV Mini Almonds Roasted and Salted.webp")
        },
        {
        name: "Bikano Navratan Mixture",
        price: "₹ 188 / 1000 g",
        priceint: 188,
        weight: 1000,
        unit: "g",
        src: require("./Bikano Navratan Mixture.webp")
        },
        {
        name: "Bingo Chilli Sprinkled Chips",
        price: "₹ 34 / 90 g",
        priceint: 34,
        weight: 90,
        unit: "g",
        src: require("./Bingo Chilli Sprinkled Chips.webp")
        },
        {
        name: "Bikano Aloo Bhujia",
        price: "₹ 95 / 400 g",
        priceint: 95,
        weight: 400,
        unit: "g",
        src: require("./Bikano Aloo Bhujia.webp")
        },
        {
        name: "Bikano All Time Mixture",
        price: "₹ 104 / 400 g",
        priceint: 104,
        weight: 400,
        unit: "g",
        src: require("./Bikano All Time Mixture.webp")
        },
        {
        name: "Bikano Combo Pack",
        price: "₹ 202 / 1000 g",
        priceint: 202,
        weight: 1000,
        unit: "g",
        src: require("./Bikano Combo Pack.webp")
        },
        {
        name: "Bikano Bikaneri Bhujia Spicy",
        price: "₹ 100 / 400 g",
        priceint: 100,
        weight: 400,
        unit: "g",
        src: require("./Bikano Bikaneri Bhujia Spicy.webp")
        },
        {
        name: "Pringles Potato Chips Sour Cream & Onion Flavor, Crispy Snack for Game Nights, On-the-Go Chips",
        price: "₹ 94 / 107 g",
        priceint: 94,
        weight: 107,
        unit: "g",
        src: require("./Pringles Potato Chips Sour Cream Onion Flavor.webp")
        },
        {
        name: "Tata Gold with 15% Long Leaves Black Tea Pouch",
        price: "₹ 330 /750 g",
        priceint: 330,
        weight: 750,
        unit: "g",
        src: require("./Tata Gold with  Long Leaves Black Tea Pouch.webp")
        },
        {
        name: "Tata Gold Black Tea Pouch",
        price: "₹ 656 /1500 g",
        priceint: 656,
        weight: 1500,
        unit: "g",
        src: require("./Tata Gold Black Tea Pouch.webp")
        },
        {
        name: "Tata Tea Premium Teaveda Tulsi, Cardamom, Ginger Black Tea Box",
        price: "₹ 121 / 250 g",
        priceint: 121,
        weight: 250,
        unit: "g",
        src: require("./Tata Tea Premium Teaveda Tulsi, Cardamom, Ginger Black Tea Box.webp")
        },
        {
        name: "Tata Premium Anokha Swad Tea Pouch",
        price: "₹ 435 / 1000 g",
        priceint: 435,
        weight: 1000,
        unit: "g",
        src: require("./Tata Premium Anokha Swad Tea Pouch.webp")
        },
        {
        name: "Red Label Natural Care Cardamom, Ginger, Liquorice, Tulsi Tea Box",
        price: "₹ 282 / 500 g",
        priceint: 282,
        weight: 500,
        unit: "g",
        src: require("./Red Label Natural Care Cardamom, Ginger, Liquorice, Tulsi Tea Box.webp")
        },
        {
        name: "Red Label Tea Pouch",
        price: "₹ 466 / 1000 g",
        priceint: 466,
        weight: 1000,
        unit: "g",
        src: require("./Red Label Tea Pouch.webp")
        },
        {
        name: "Tata Gold Care Tea Pouch",
        price: "₹ 424 /1000 g",
        priceint: 424,
        weight: 1000,
        unit: "g",
        src: require("./Tata Gold Care Tea Pouch.webp")
        },
        {
        name: "Flipkart Supermart Food Essentials Premium Tea Pouch",
        price: "₹ 72 /250 g",
        priceint: 72,
        weight: 250,
        unit: "g",
        src: require("./Flipkart Supermart Food Essentials Premium Tea Pouch.webp")
        },
        {
        name: "Flipkart Supermart Green Tea Bags Box",
        price: "₹ 50 /25 g",
        priceint: 50,
        weight: 25,
        unit: "Bags",
        src: require("./Flipkart Supermart Green Tea Bags Box.webp")
        },
        {
        name: "Tata Tea Premium Teaveda Tulsi, Cardamom, Ginger Black Tea Box",
        priceint: 223,
        price: "₹ 223 / 500 g",
        weight: 500,
        unit: "g",
        src: require("./Tata Tea Premium Teaveda Tulsi, Cardamom, Ginger Black Tea Box.webp")
        },
        {
        name: "Flipkart Supermart Food Essentials Premium Tea Pouch",
        price: "₹ 144 / 500 g",
        priceint: 144,
        weight: 500,
        unit: "g",
        src: require("./Flipkart Supermart Food Essentials Premium Tea Pouch.webp")
        },
        
        ]
        export default packaged_products_images